const mapStateToProps = (state) => {
    const {
        user:{
            rights,
        }={},
    } = state;
    return {
        rights,
    }
}

export default mapStateToProps;